import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import i18next from 'i18next'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import ScheduleSummaryDetail from './ScheduleSummaryDetail'
import ScheduleSummaryDetailJobInstruction from './ScheduleSummaryDetailJobInstruction'
import ScheduleJobFile from './ScheduleJobFile'
import { format } from 'react-string-format';
import ScheduleDescriptionWeekDay from './ScheduleDescriptionWeekDay';
import * as storage from '../../utils/storage';
import { withNamespaces } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    divAccordion: {
        backgroundColor: '#efefef !important',
        color: '#000000 !important',
        marginBottom: '10px',
        boxShadow: '0px 0px 3px 0px !important',
    },
    divTime: {
        float: 'left',
        width: '100%',
        color: '#000000'
    },
    divTimeLabel: {
        float: 'left',
        display: 'table',
        width: '75px',
        textAlign: 'right',
        marginRight: '5px',
        fontWeight: 'bold'
    },
    divTimeDescription: {
        display: 'table'
    },
    divTab: {
        width: '100%',
    },
    divDescriptionDay: {
        float: 'right',
        marginLeft: '20px',
        fontSize: '12px'
    },
    appBar: {
        backgroundColor: '#efefef',
    },
    detail: {
        padding: '0px 0px !important',
        border: '1px solid #d3d3d3'
    },
    divDetail: {
        minHeight: '150px'
    },
    tabButtonPlanif: {
        fontSize: '15px !important'
    },
    tabWithFile: {
        '&::after': {
            content: '" *"',
            color: 'red'
        }
    }
}));

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

function TabScheduleDetail(props) {
    const [value, setValue] = React.useState(0);
    const [index, setIndex] = React.useState(0);
    const [isWorkInstructionUse, setIsWorkInstructionUse] = React.useState(false);
    const [data, setData] = React.useState(null);
    const [hasFile, setHasFile] = React.useState(false);

    const classes = useStyles();

    useEffect(() => {
        setIsWorkInstructionUse(storage.getUseWorkInstructions());
    }, []);

    useEffect(() => {
        if (props.data !== null && props.data !== undefined) {
            setData(props.data);
            setHasFile(props.data?.documents.length > 0)
        }
    }, [props.data]);


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleDetailDemandeClick = () => {
        setIndex(0);
    }

    const handleDetailItemClick = () => {
        setIndex(1);
    }

    const handleFilesItemClick = () => {
        setIndex(2);
    }

    return (
        <React.Fragment>
            <AppBar position="static" color="default" className={classes.appBar}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="standard"
                    indicatorColor="primary"
                    textColor="primary"
                    className={"TabNoShadow"}
                >
                    <Tab className={`TabPageButton ${classes.tabButtonPlanif}`} label={data?.clientDescription !== null && data?.clientDescription.length > 0 ? i18next.t("schedule:tabPanel.infoClient") : i18next.t("schedule:tabPanel.infoPlanif")} {...a11yProps(0)} onClick={handleDetailDemandeClick} />
                    {data?.clientDescription !== null && data?.clientDescription.length > 0 && isWorkInstructionUse && <Tab className={`TabPageButton ${classes.tabButtonPlanif}`} label={i18next.t("schedule:tabPanel.instruction")} {...a11yProps(1)} onClick={handleDetailItemClick} />}
                    {data?.clientDescription !== null && data?.clientDescription.length > 0 && <Tab className={`TabPageButton ${classes.tabButtonPlanif} ${hasFile ? classes.tabWithFile : ''}`} label={i18next.t("schedule:tabPanel.files")} {...a11yProps(2)} onClick={handleFilesItemClick} />}
                </Tabs>
            </AppBar>

            <div className={classes.divDetail}>
                {index == 0 && <ScheduleSummaryDetail data={data} />}
                {index == 1 && <ScheduleSummaryDetailJobInstruction data={data} />}
                {index == 2 && <ScheduleJobFile data={data?.documents} />}
            </div>

            {(data?.isTwoDaysShiftNight || data?.isSameDayShiftMorning) &&
                <div className={classes.divDescriptionDay}>
                    {data?.isTwoDaysShiftNight && format('* ' + i18next.t('schedule:list.twoDaysShift'), <ScheduleDescriptionWeekDay date={data?.startDate} lowerCase={true} />, <ScheduleDescriptionWeekDay date={data?.endDate} lowerCase={true} />)}
                    {data?.isSameDayShiftMorning && format('* ' + i18next.t('schedule:list.sameDayShift'), <ScheduleDescriptionWeekDay date={data?.startDate} lowerCase={true} />)}
                </div>
            }
        </React.Fragment>
    );
}

export default withNamespaces(['schedule', 'common'], { wait: true })(TabScheduleDetail);